// extracted by mini-css-extract-plugin
export default {"root":"MarkModal_root__4986r","btns":"MarkModal_btns__u2pA-","container":"MarkModal_container__RL1a7","title":"MarkModal_title__XQWxO","content":"MarkModal_content__vD-Ag"};